import mitt from 'mitt'

const emitter = mitt()

export function useToast() {
    const addToast = (message, duration = 3000, subtitle = null, image = null, button = null) => {
        emitter.emit('toast:add', {
            message,
            duration,
            subtitle,
            image,
            button,
        })
    }

    return {
        addToast,
        emitter,
    }
}

export const toastPlugin = {
    install(app) {
        const { addToast } = useToast()

        app.config.globalProperties.$toast = addToast
        app.provide('toast', addToast)
    },
}
